import { useEffect, useRef, useState } from "react";
import TeamBadge from "@/components/base/TeamBadge";
import StatusBadge from "@/components/base/StatusBadge";
import type { SportEvent } from "@/mocks/events";

export default function ScoreBoard({ event }: { event: SportEvent }) {
  const [homeScore, setHomeScore] = useState(event.homeScore);
  const [awayScore, setAwayScore] = useState(event.awayScore);
  const [tick, setTick] = useState(0);
  const stepRef = useRef(0);

  useEffect(() => {
    if (event.status !== "live") return;
    const timer = window.setInterval(() => {
      stepRef.current += 1;
      const step = stepRef.current;
      if (step % 2 === 0) {
        const add = event.sport === "football" ? 1 : Math.floor(Math.random() * 3) + 1;
        if (Math.random() > 0.5) setHomeScore((s) => s + add);
        else setAwayScore((s) => s + add);
      }
      setTick((t) => t + 1);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [event.status, event.sport]);

  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
      <div className="flex items-center justify-between gap-3">
        <StatusBadge status={event.status} />
        <span className="flex items-center gap-1.5 text-xs text-foreground-500">
          <i className="ri-group-line" />
          在线 {event.viewers}
        </span>
      </div>

      <div className="mt-5 flex items-center justify-between gap-3">
        <div className="flex w-[38%] flex-col items-center gap-2">
          <TeamBadge team={event.home} size={56} />
          <span className="text-center text-sm font-semibold text-foreground-900">
            {event.home.name}
          </span>
        </div>

        <div className="flex flex-col items-center gap-1">
          <div className="font-heading text-4xl font-extrabold tracking-tight text-foreground-950 md:text-5xl">
            <span className={event.status === "live" ? "text-primary-400" : ""}>
              {homeScore}
            </span>
            <span className="mx-2 text-foreground-400">:</span>
            <span className={event.status === "live" ? "text-primary-400" : ""}>
              {awayScore}
            </span>
          </div>
          <span className="text-xs font-medium text-foreground-500">
            {event.progress}
          </span>
        </div>

        <div className="flex w-[38%] flex-col items-center gap-2">
          <TeamBadge team={event.away} size={56} />
          <span className="text-center text-sm font-semibold text-foreground-900">
            {event.away.name}
          </span>
        </div>
      </div>

      <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 border-t border-background-200 pt-4">
        <span className="flex items-center gap-1.5 text-xs text-foreground-500">
          <i className="ri-trophy-line text-primary-400" />
          {event.league}
        </span>
        <span className="flex items-center gap-1.5 text-xs text-foreground-500">
          <i className="ri-time-line" />
          {event.time}
        </span>
        {event.status === "live" && (
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-refresh-line" />
            已刷新 {tick} 次（演示）
          </span>
        )}
      </div>
    </div>
  );
}